module.exports = __webpack_public_path__ + "img/emas.40e9eb49.jpg";